import "./utils/cm";
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider as StoreProvider} from "./models/index";
import {HashRouter} from "react-router-dom";
import {ConfigProvider} from 'antd';
import 'moment/locale/zh-cn';
import zhCN from 'antd/es/locale/zh_CN';
import MainLayout from './pages/layout/MainLayout';
import "./index.less";
import moment from "moment";

moment.fn.toISOString = function () {
    return this.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
}

const Index = () => (

    <StoreProvider>
        <HashRouter>
            <ConfigProvider locale={zhCN}>
                <MainLayout/>
            </ConfigProvider>
        </HashRouter>
    </StoreProvider>
)

ReactDOM.render(
    <Index/>,
    document.getElementById('root')
);
